import { render, staticRenderFns } from "./PurchasingInJointNamesInfo.vue?vue&type=template&id=90c6b538&"
import script from "./PurchasingInJointNamesInfo.vue?vue&type=script&lang=js&"
export * from "./PurchasingInJointNamesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports